(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game-skeleton.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game-skeleton.js');
"use strict";


const Skeleton = svs.components.lbUi.Skeleton;
const GameSkeleton = () => React.createElement("div", {
  className: "margin-half",
  style: {
    display: 'inline-flex',
    flexDirection: 'row'
  }
}, React.createElement(Skeleton, {
  height: 4,
  numLines: 1,
  style: {
    width: '96px'
  }
}), React.createElement("div", {
  className: "margin-left"
}, React.createElement(Skeleton, {
  className: "margin-half",
  height: 1,
  numLines: 1,
  style: {
    width: '200px',
    maxHeight: '12px'
  }
}), React.createElement(Skeleton, {
  className: "margin-half",
  height: 1,
  numLines: 1,
  style: {
    width: '150px',
    maxHeight: '12px'
  }
}), React.createElement(Skeleton, {
  className: "margin-half",
  height: 1,
  numLines: 1,
  style: {
    width: '150px',
    maxHeight: '12px'
  }
})));
setGlobal('svs.components.marketplace.gameList.GameSkeleton', GameSkeleton);

 })(window);